import request from './request'

/** 请求验证-开通虚拟账户 */
export function openAccount(data: any) {
	return request({
		method: 'POST',
		url: '/api/old_business/openAccount',
		data,
		reportError: (res) => res.code !== 2001,
	})
}

/** 请求验证-绑定银行卡 */
export function bindBank({ bank_account, bank_simple_name, mobile }: any) {
	return request({
		method: 'POST',
		url: '/api/old_business/bindBank',
		data: {
			bank_account,
			bank_simple_name,
			mobile,
		},
		reportError: false,
	})
}

/** 绑定银行卡-验证确认 */
export function bindBankVerify(amount: number, sms_code: string) {
	return request.post('/api/old_business/bindBankVerify', {
		amount,
		sms_code,
	})
}

/** 验证结果查询 */
export function bindVerifyQuery(seqId: string) {
	return request.get('/api/old_business/bindVerifyQuery', {
		params: { tb_bind_verify_seqid: seqId },
	})
}

/** 签约行为上报 */
export function signBehavior() {
	return request.post('/api/old_business/signBehavior', {
		channel: 2,
	})
}
